<template>
  <div class="pg-operation-tip" v-if="show" @click="hide">
    <div class="pg-operation-tip__hole" :style="boxStyle"></div>
    <div class="pg-operation-tip__tip" :style="tipStyle">
      <span class="pg-operation-tip__tip-arrows"></span>
      <div class="pg-operation-tip__tip-content">
        <div class="pg-operation-tip__tip-content-top">
          <span class="pg-operation-tip__tip-content-top-icon"></span>
          <span>操作小秘诀</span>
        </div>
        <div class="pg-operation-tip__tip-content-bottom">
          <p class="pg-operation-tip__tip-content-title">拖拽</p>
          <span class="pg-operation-tip__tip-content-bottom-text"
            >鼠标移至组件标题区域出现拖拽图标，就可以调整组件顺序哦～</span
          >
        </div>
        <span class="pg-operation-tip__tip-content-btn">我知道啦</span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, shallowRef, onUnmounted } from 'vue'
const props = defineProps({
  //在localstorage中key
  storageKey: String,
})

const show = ref(false)
onMounted(() => {
  if (props.storageKey) {
    show.value = !localStorage.getItem(props.storageKey)
  }
})
const hide = () => {
  show.value = false
  if (props.storageKey) {
    localStorage.setItem(props.storageKey, true)
  }
}

//定位的坐标{x, y}
const position = ref(null)
const boxStyle = computed(() => {
  return {
    top: `${(position.value?.y ?? 0) - 5}px`,
    left: `${position.value?.x ?? 0}px`,
  }
})
const tipStyle = computed(() => {
  return {
    top: `${position.value?.y ?? 0}px`,
    left: `${(position.value?.x ?? 0) + 230}px`,
  }
})

//计算元素的x,y左坐标
function getXY(obj) {
  var x = 0,
    y = 0
  if (obj.getBoundingClientRect) {
    var box = obj.getBoundingClientRect()
    var D = document.documentElement
    x = box.left + Math.max(D.scrollLeft, document.body.scrollLeft) - D.clientLeft
    y = box.top + Math.max(D.scrollTop, document.body.scrollTop) - D.clientTop
  } else {
    while (obj != document.body) {
      ;(x += obj.offsetLeft), (y += obj.offsetTop), (obj = obj.offsetParent)
    }
  }
  return {
    x: x,
    y: y,
  }
}

//解决按钮未返回时导致定位不准确
const timer = shallowRef(null)
const count = shallowRef(1)
const setPosition = (dom) => {
  if (!show.value) return
  if (timer.value) {
    clearTimeout(timer.value)
  }
  position.value = getXY(dom)
  if (count.value < 5) {
    timer.value = setTimeout(() => {
      count.value += 1
      setPosition(dom)
    }, 200)
  }
}
onUnmounted(() => {
  if (timer.value) {
    clearTimeout(timer.value)
  }
})

defineExpose({
  setPosition,
})
</script>
<style lang="scss">
@import '../style/operation-tip';
</style>
